import { Component, OnInit } from '@angular/core';
import { SettingsService, UserService } from '../../services';
import { OrganisationTypeEnum } from '../../enums/organisation-types';
import localforage from 'localforage';
import { ActivatedRoute } from '@angular/router';

const VIEW_TYPE_KEY = 'job-screen-view-type';

@Component({
  selector: 'app-job-screen-container',
  templateUrl: './job-screen-container.component.html',
  styleUrls: ['./job-screen-container.component.scss'],
})
export class JobScreenContainerComponent implements OnInit {
  organisationTypeEnum = OrganisationTypeEnum;
  organisationTypeId: number;
  organisationId: any;
  currentOrg: any;
  viewType: number | null = null;

  newJobScreenEnabled = false;

  isRoute: boolean | null = null;

  constructor(
    private userService: UserService,
    private settingsService: SettingsService,
    private route: ActivatedRoute,
  ) {
    const currentOrgPromise = this.userService.getCurrentUserOrg();

    currentOrgPromise.then((org) => {
      this.currentOrg = org;
      this.organisationTypeId = org.organisationTypeId;
      this.organisationId = org.id;
    });
  }

  async ngOnInit() {
    const settings = await this.settingsService.GetSystemSettings();
    this.newJobScreenEnabled = settings.newJobScreenEnabled;
    if (!this.newJobScreenEnabled) {
      void localforage.setItem(VIEW_TYPE_KEY, 0);
      this.viewType = 0;
      return;
    }
    const preferredViewType = await localforage.getItem<number>(VIEW_TYPE_KEY);
    this.viewType = preferredViewType || 0;

    this.isRoute = this.route.snapshot.data?.isRoute ?? false;

    this.route.data.subscribe((data) => {
      this.isRoute = data.isRoute ?? false;
    });
  }

  viewTypeChanged($event: number) {
    this.viewType = $event;
    void localforage.setItem(VIEW_TYPE_KEY, this.viewType);
  }
}
